import { CheckBadgeIcon, ExclamationTriangleIcon } from '@heroicons/react/20/solid';
import { toast as rht } from 'react-hot-toast';

import { cn } from '~/styling';

const success = (message: string | JSX.Element) => {
  return rht.custom((t) => (
    <div
      className={cn(
        'bg-primary-4-10 px-6 py-4 drop-shadow',
        t.visible ? 'animate-enter' : 'animate-leave'
      )}
    >
      <div className="flex items-center gap-3 font-heading text-xs font-medium text-primary-1-80">
        <div className="">
          <CheckBadgeIcon className="h-4 w-4" />
        </div>
        <div className="">{message}</div>
      </div>
    </div>
  ));
};

const error = (message: string) => {
  return rht.custom((t) => (
    <div
      className={cn(
        'bg-secondary-3 px-6 py-4 drop-shadow',
        t.visible ? 'animate-enter' : 'animate-leave'
      )}
    >
      <div className="flex items-center gap-3 font-heading text-xs font-medium text-[#DE3A3A]">
        <div className="">
          <ExclamationTriangleIcon className="h-4 w-4" />
        </div>
        <div className="">{message}</div>
      </div>
    </div>
  ));
};

const toast = {
  success,
  error,
};

export default toast;
